import { canv } from "@/canv/global";

const fontAssetCache = new Map<string, Promise<ArrayBuffer>>();
const failedFontAssets = new Set<string>();

const fetchFontAsset = async (url: string): Promise<ArrayBuffer> => {
    const response = await fetch(`${canv.host}${url}`, { cache: "force-cache" });
    if (!response.ok) {
        throw new Error(`Failed to fetch font asset: ${response.status} ${response.statusText}`);
    }

    return response.arrayBuffer();
};

export const getFontAsset = (url: string): Promise<ArrayBuffer> => {
    const cached = fontAssetCache.get(url);
    if (cached) return cached;

    // Кэшируем и успешные, и неуспешные попытки, чтобы не спамить одинаковыми запросами при ошибке.
    const promise = fetchFontAsset(url)
        .then((asset) => {
            failedFontAssets.delete(url);
            return asset;
        })
        .catch((err) => {
            failedFontAssets.add(url);
            throw err;
        });
    fontAssetCache.set(url, promise);
    return promise;
};

export const invalidateFailedFontAsset = (url: string): void => {
    if (failedFontAssets.has(url)) {
        failedFontAssets.delete(url);
        fontAssetCache.delete(url);
    }
};
